import BoxWithLogo from "@/components/logoBox";
import { UTILIZATION_CONSTANTS } from "./constants";

const UtilizationComp = () => {
  return <BoxWithLogo {...UTILIZATION_CONSTANTS} />;
};

export default UtilizationComp;
